export default __webpack_public_path__ + "static/media/print.420fc492.svg";